module.exports = __webpack_public_path__ + "static/media/shopping-cart.502fdc47.svg";